import type { Schedulable } from '@empathyco/playboard-core-domain'
import { DomainDateUtils } from '@empathyco/playboard-core-domain'
import { DateUtils } from './date.utils'

export class ScheduleUtils {
  static isDateWithinSchedule(date: Date, schedule: Schedulable['schedule']): boolean {
    const getDate = (value?: Date | null): Date | undefined =>
      value instanceof Date ? new Date(value.getTime()) : undefined

    const scheduleToCompareWithoutHours = DateUtils.getPeriodWithoutHours({
      start: getDate(schedule.activationDate),
      end: getDate(schedule.deactivationDate),
    })

    const scheduleToCompareMilliseconds = DomainDateUtils.getPeriodToCompare(
      scheduleToCompareWithoutHours,
    )

    return (
      scheduleToCompareMilliseconds.start <= date.getTime() &&
      scheduleToCompareMilliseconds.end >= date.getTime()
    )
  }
  static isScheduleActive(schedule: Schedulable['schedule']): boolean {
    const today = new Date()
    const activatesInTheFuture =
      schedule.activationDate && schedule.activationDate.getTime() > today.getTime()
    const isDeactivated =
      schedule.deactivationDate && schedule.deactivationDate.getTime() < today.getTime()

    return !activatesInTheFuture && !isDeactivated
  }
}
